/**
 * Service to handle OAuth 2.0 flows for Marketplace integrations.
 * 
 * NOTE: For production, you must replace the CLIENT_IDs with actual values from
 * the respective developer portals.
 */

const EBAY_CLIENT_ID = "YOUR_EBAY_CLIENT_ID"; // Sandbox or Production ID
const EBAY_REDIRECT_URI = window.location.origin + "/auth/ebay/callback";

// Amazon Seller Central App Client ID
const AMAZON_CLIENT_ID = "YOUR_AMAZON_CLIENT_ID";
const AMAZON_REDIRECT_URI = window.location.origin + "/auth/amazon/callback";

export const authService = {

    /**
     * Initiates the OAuth flow for a specific provider.
     */
    initiateOAuth: (provider: 'ebay' | 'amazon') => {
        let authUrl = '';
        const state = Math.random().toString(36).substring(7);
        localStorage.setItem(`${provider}_auth_state`, state);

        if (provider === 'ebay') {
            // eBay OAuth URL (User Access Token)
            // Scope: https://api.ebay.com/oauth/api_scope/sell.inventory
            const scopes = encodeURIComponent("https://api.ebay.com/oauth/api_scope/sell.inventory");
            authUrl = `https://auth.ebay.com/oauth2/authorize?client_id=${EBAY_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(EBAY_REDIRECT_URI)}&scope=${scopes}&state=${state}`;
        } else if (provider === 'amazon') {
            // Amazon Seller Partner API OAuth
            authUrl = `https://sellercentral.amazon.com/apps/authorize/consent?application_id=${AMAZON_CLIENT_ID}&state=${state}&version=beta`; // check docs for exact URL structure
        }

        if (authUrl) {
            window.location.href = authUrl;
        }
    },

    /**
     * Handles the callback from the OAuth provider (to be called on the callback page/route).
     * Returns the auth code if successful.
     */
    handleCallback: (provider: 'ebay' | 'amazon') => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const storedState = localStorage.getItem(`${provider}_auth_state`);

        if (state !== storedState) {
            console.error("State mismatch. Possible CSRF attack.");
            return null;
        }

        if (code) {
            // In a real app, you would swap this code for a token via your backend.
            // For this frontend-only demo, we'll store the code as a "success" marker.
            localStorage.setItem(`${provider}_auth_code`, code);
            return code;
        }
        return null;
    },

    isAuthenticated: (provider: 'ebay' | 'amazon') => {
        return !!localStorage.getItem(`${provider}_auth_code`);
    },

    disconnect: (provider: 'ebay' | 'amazon') => {
        localStorage.removeItem(`${provider}_auth_code`);
    }
};
